// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"d3c0b7a5","631":"721d2738","774":"1b956845","820":"5218447e","851":"36632170","858":"3526e402"}[chunkId] + ".chunk.js";
};